import { Box, Text } from "@chakra-ui/react";
import React from "react";

/**
 * The table chrome shared by the Sandata and HHAeXchange mapping tabs. Only the last data column
 * differs between them, so it is named by the caller.
 */
export default function MappingTableShell(props: {
  externalColumnHeader: string;
  isEmpty: boolean;
  emptyMessage: string;
  children: React.ReactNode;
}) {
  return (
    <Box>
      <div className="table-responsive">
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th>Section</th>
              <th>Plan of Care Item</th>
              <th>Medflyt Code</th>
              <th>{props.externalColumnHeader}</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {props.children}
            {props.isEmpty && (
              <tr>
                <td colSpan={5}>
                  <Text color="gray.500" mb={0}>
                    {props.emptyMessage}
                  </Text>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </Box>
  );
}
